import i18next from 'i18next'
import { fromJS } from 'immutable'
import { NotificationProps } from '../../types/notificationTypes'
import { AppStateType } from '../../utils/appStateReduxStore'
import { uuidv4 } from '../../utils/uuid'
import {
  ADD_FEEDBACK_NOTIFICATION,
  ADD_NOTIFICATION,
  DISMISS_ALL_NOTIFICATIONS,
  DISMISS_FEEDBACK_NOTIFICATION,
  DISMISS_NOTIFICATION
} from '../actionTypes'
import { ThunkDispatch } from './baseHelpers'

export const dismissNotification = (id: number | string) => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: DISMISS_NOTIFICATION,
    id
  })
}
export const addFeedbackNotification = () => (dispatch: ThunkDispatch) => {
  dispatch({
    type: ADD_FEEDBACK_NOTIFICATION,
    id: uuidv4()
  })
}
export const dismissFeedbackNotification = () => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: DISMISS_FEEDBACK_NOTIFICATION
  })
}
export const dismissAllNotifications = () => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: DISMISS_ALL_NOTIFICATIONS
  })
}

export const addNoAccessNotification = () =>
  addNotification({
    title: i18next.t('application.noAccessTitle'),
    message: i18next.t('application.noAccessMessage'),
    timeout: 10000,
    type: 'error'
  })

export const addNotification =
  (props: NotificationProps) => (dispatch: ThunkDispatch, getState: () => AppStateType) => {
    const id = props.id ? props.id : uuidv4()
    const action = dispatch({
      type: ADD_NOTIFICATION,
      id,
      props: fromJS(props)
    })

    if (props.timeout && props.timeout > 0) {
      const added = getState().getIn(['notifications', id])
      // Skip if the notification was re-added or changed since, so an old timer does not cut a new one short
      setTimeout(() => {
        if (getState().getIn(['notifications', id]) === added) {
          dispatch(dismissNotification(id))
        }
      }, props.timeout)
    }

    return action
  }

export const unresolvedAddressesNotificationId = 'unresolvedAddressesNotification'
export const addUnresolvedAddressesNotification =
  (unresolvedCount: number, departmentId: number, navigateToBasePath = '/planner') =>
  (dispatch: ThunkDispatch) => {
    dispatch(
      addNotification({
        id: unresolvedAddressesNotificationId,
        title: i18next.t('coordinates.setCoordinates'),
        message: i18next.t('coordinates.thereAreUnsetCoordinates', { count: unresolvedCount }),
        type: 'error',
        button: 'navigateOrDismiss',
        navigateTo: `${navigateToBasePath}/${departmentId}/coordinates`
      })
    )
  }
